module.exports = __webpack_public_path__ + "img/square-small.d79580a6.svg";